// extracted by mini-css-extract-plugin
module.exports = {"root":"GeneratedRoutesLayout_root__3Xp0Y","routesList":"GeneratedRoutesLayout_routesList__2bsqA"};